import { createContext, useState, useEffect } from 'react';

import { onAuthStateChangedListener, createUserDocumentFromAuth } from '../utils/firebase.utils';


export const UserContext = createContext({
	currentUser: null,
	setCurrentUser: () => null,
});

export const UserProvider = ({children}) => {
	const [ currentUser, setCurrentUser ] = useState(null);

	const value = { currentUser, setCurrentUser };

	useEffect(() => {
		const unsubscribe = onAuthStateChangedListener((user) => {
			if (user) {
				createUserDocumentFromAuth(user);
			}
			setCurrentUser(user);
		});

		return unsubscribe;
	}, []);


	return (
		<UserContext.Provider value={value} >
			{children}
		</UserContext.Provider>
	);
};



export const UserNameContext = createContext({
	userName: null,
	setUserName: () => null,
});

export const UserNameProvider = ({children}) => {
	const [ userName, setUserName ] = useState('');

	const value = { userName, setUserName };

	useEffect(() => {

	}, []);


	return (
		<UserNameContext.Provider value={value} >
			{children}
		</UserNameContext.Provider>
	);
};